import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shared axios instance for admin — sends and stores httpOnly cookies.
const admin = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "حدث خطأ. حاول مجددًا.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// ----- Auth -----
export async function login(email, password) {
  const { data } = await admin.post("/auth/login", { email, password });
  return data;
}
export async function logout() {
  await admin.post("/auth/logout");
}
export async function me() {
  const { data } = await admin.get("/auth/me");
  return data;
}

// ----- Content CRUD -----
export async function listAdmin(entity) {
  const { data } = await admin.get(`/admin/${entity}`);
  return data;
}
export async function getAdmin(entity, id) {
  const { data } = await admin.get(`/admin/${entity}/${id}`);
  return data;
}
export async function createAdmin(entity, payload) {
  const { data } = await admin.post(`/admin/${entity}`, payload);
  return data;
}
export async function updateAdmin(entity, id, payload) {
  const { data } = await admin.put(`/admin/${entity}/${id}`, payload);
  return data;
}
export async function deleteAdmin(entity, id) {
  const { data } = await admin.delete(`/admin/${entity}/${id}`);
  return data;
}

// ----- Download stats -----
export async function listDownloads() {
  const { data } = await admin.get("/admin/downloads");
  return data; // { total, stats: {slug: {count, title}}, requests: [...] }
}

// ----- Media uploads -----
export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await admin.post("/admin/media/image", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { url, filename, size }
}
export async function uploadPdf(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await admin.post("/admin/media/pdf", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
